import { useStyletron } from 'baseui';
import { DateTime } from 'luxon';
import { AssignmentDueBackgroundColourMap, AssignmentDueColourMap, hexToRGB } from '@gtintel/platform-utils';
const DueDatePill = ({
  dueDate,
  submittedDate
}) => {
  const [css] = useStyletron();
  let dueStatus;
  let diff;
  if (submittedDate) {
    diff = DateTime.fromISO(dueDate).diff(DateTime.fromISO(submittedDate), 'days').days;
  } else {
    diff = DateTime.fromISO(dueDate).diff(DateTime.now(), 'days').days;
  }
  if (diff > 6) {
    dueStatus = 'onTime';
  } else if (diff === 0) {
    dueStatus = 'due';
  } else if (diff < 6 && diff > 0) {
    dueStatus = 'dueSoon';
  } else {
    dueStatus = 'late';
  }
  return <div className={css({
    background: hexToRGB(AssignmentDueBackgroundColourMap[dueStatus], 0.2),
    borderRadius: '4px',
    color: AssignmentDueColourMap[dueStatus],
    padding: '2px 8px',
    width: 'fit-content'
  })}>
      <p className={css({
      margin: 0
    })}>
        <strong>
          {dueDate ? DateTime.fromISO(dueDate, {
          zone: 'utc'
        }).toLocaleString() : 'Due date not set'}
        </strong>
      </p>
    </div>;
};
export default DueDatePill;